import * as ActionType from '../../constants/actionType';

export const setBroadcastVolume = (tasks) => ({type: ActionType.SET_BROADCAST_VOLUME, tasks});

export function setCardBroadcastProperty(cardId, data) {
  return {
    type: ActionType.SET_CARD_REUSE_TIP,
    cardId,
    data,
  };
}

export default {};
